import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AuthGuard } from '~/app/auth/guard/AuthGuard';
import { useAuth } from '~/app/auth/context/AuthContext';
import { Loader } from '~/app/components/common/Loader/Loader';

import { HEADER_HEIGHT } from './layout.constants';
import { LandingMainShell } from './LandingMainShell';
import { LandingTopHeader } from './LandingTopHeader';
import { useLandingAccountMenu } from './useLandingAccountMenu';

export function LandingLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout, isLoading } = useAuth();

  const accountMenu = useLandingAccountMenu(user, logout);

  const initials = (user?.name ?? user?.email ?? 'EV')
    .slice(0, 2)
    .toUpperCase();

  if (isLoading) {
    return <Loader />;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthGuard>
      <div className="landing-app-shell">
        <LandingMainShell
          collapsed={collapsed}
          onCollapsedChange={setCollapsed}
          header={
            <LandingTopHeader
              user={user}
              initials={initials}
              accountMenu={accountMenu}
              headerHeight={HEADER_HEIGHT}
            />
          }
          routedContent={<Outlet />}
        />
      </div>
    </AuthGuard>
  );
}
